export const PRICE = '$23'

export const BRAND = 'Barber Instructor Ready™'

/** Section 2 — real Volume 2 pages, in this exact order. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/nfobrhHbfHGM9ZkMNKKfL2/01_pagina_15.webp',
    caption: 'Low, Mid, High & Skin Fades — Page 15',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tkRwcdBD42Vujk6KwU6pxQ/02_pagina_09.webp',
    caption: "Classic Men's Haircuts — Page 9",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bEFedc1HbXUeQczArdRwoF/03_pagina_18.webp',
    caption: 'Taper, Drop & Burst Fades — Page 18',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kntD6PoNvXbHKjwaEEMT7v/04_pagina_25.webp',
    caption: 'Beard Design, Trimming & Shaving — Page 25',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tDuRbDdsxEZsVnQAG1EHjK/05_pagina_42.webp',
    caption: 'Top 5 Clipper Errors Students Make — Page 42',
  },
]

/** Section 3 — pain points. */
export const painPoints = [
  {
    title: 'Hours of Lesson Preparation',
    text: 'Building classes from scratch takes time you could spend teaching or growing your business.',
  },
  {
    title: 'Scattered Teaching Materials',
    text: 'Worksheets, lesson ideas and technique references spread across different places.',
  },
  {
    title: 'Repeating the Same Demonstrations',
    text: 'Students need structured practice and feedback — not just another explanation.',
  },
  {
    title: 'No Consistent Teaching System',
    text: 'Without a clear structure, planning, practice and assessment become harder to manage.',
  },
]

/** Section 5 — the six volumes. Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Barber Education Foundations & Professional Teaching Essentials',
    description:
      'Tools, sanitation, consultation, head shape and the core foundations your students need before they ever pick up a clipper.',
    accent: '#EEF4FA',
  },
  {
    number: 2,
    title: "The Complete Men's Haircutting & Barbering Technique Library",
    description:
      'Fades, tapers, classic cuts, modern styles and beard techniques — visual references you can put on screen and teach from.',
    accent: '#D8EAF7',
  },
  {
    number: 3,
    title: 'The Ready-to-Teach Barbering Lesson System',
    description:
      'Complete class structures and teaching guides, so every session starts with a plan instead of a blank page.',
    accent: '#DCECDF',
  },
  {
    number: 4,
    title: 'The Barber Student Practice & Skills Workbook',
    description:
      'Hands-on exercises, worksheets and practice plans that keep students working with purpose between demonstrations.',
    accent: '#FFF0C2',
  },
  {
    number: 5,
    title: 'The Barber Student Assessment & Certification Toolkit',
    description:
      'Practical evaluations, rubrics and feedback forms to measure technique and track each student’s progress.',
    accent: '#F9D5C8',
  },
  {
    number: 6,
    title: 'The Barber Instructor Curriculum & Classroom Management System',
    description:
      'Organization systems, policies and planning tools to run a more consistent barber training program.',
    accent: '#E8DDF5',
  },
]

export const volumeFlow = ['Foundations', 'Techniques', 'Lessons', 'Practice', 'Assessment', 'Classroom']

/** Section 6 — visual resources included. */
export const visualResources = [
  'Fade height maps',
  'Classic cut silhouettes',
  'Taper, drop & burst guides',
  'Clipper guard references',
  'Beard design breakdowns',
  'Sectioning plans',
  'Teaching tasks per technique',
  'Common student errors',
  'Correction strategies',
  'Step-by-step demonstrations',
]

/** Section 7 — the five bonuses. */
export const bonuses = [
  {
    number: 'Bonus #1',
    title: 'The Barber Instructor Visual Teaching Library™',
    description:
      'Diagrams, head maps and technique visuals that help students see exactly what you are explaining.',
    badge: 'Visuals Ready',
    accent: '#D8EAF7',
  },
  {
    number: 'Bonus #2',
    title: 'The Barber Instructor Quick-Start Classroom Kit™',
    description: 'Everything you need to set up a class fast — first-day resources, routines and checklists.',
    badge: 'Class Set Up Fast',
    accent: '#DCECDF',
  },
  {
    number: 'Bonus #3',
    title: 'The Barber Student Troubleshooting & Skill Correction Vault™',
    description:
      'The most common technique mistakes, why they happen and how to correct them before they become habits.',
    badge: 'Corrections Ready',
    accent: '#FFF0C2',
  },
  {
    number: 'Bonus #4',
    title: 'The Barber Educator Interactive Classroom Toolkit™',
    description: 'Activities, discussion prompts and quick games that keep students engaged and participating.',
    badge: 'Engagement Ready',
    accent: '#F9D5C8',
  },
  {
    number: 'Bonus #5',
    title: 'The Barber Student Career & Portfolio Launch Kit™',
    description:
      'Portfolio templates and career-prep resources to help students present their work and plan their next step.',
    badge: 'Career Ready',
    accent: '#E8DDF5',
  },
]

/** Section 8 — before and after. */
export const withoutSystem = [
  'Creating lessons from scratch',
  'Searching for worksheets',
  'Repeating instructions without a clear practice plan',
  'Tracking progress inconsistently',
  'Managing scattered classroom materials',
]

export const withSystem = [
  'Organized lesson frameworks',
  'Student practice resources',
  'Clear technique references',
  'Assessment and feedback tools',
  'Classroom planning resources',
]

/** Section 9 — who it is for. */
export const audience = [
  'Barber Instructors',
  'Barber School Teachers',
  'Barber Academy Owners',
  'Barbering Educators & Trainers',
]

/** Section 10 — value stack. */
export const offerIncludes = [
  '6 Complete Barber Teaching Volumes',
  'Visual Teaching Library™',
  'Quick-Start Classroom Kit™',
  'Troubleshooting & Skill Correction Vault™',
  'Interactive Classroom Toolkit™',
  'Career & Portfolio Launch Kit™',
]

/** Section 11 — what one resource saves. */
export const onePartItems = [
  "One fade diagram you don't have to draw.",
  "One lesson you don't have to plan.",
  "One worksheet you don't have to build.",
  "One assessment you don't have to prepare.",
]

export const faqs = [
  {
    question: 'Is this a physical product?',
    answer: 'No. Barber Instructor Ready™ is a digital educational resource collection.',
  },
  {
    question: 'Who is this system for?',
    answer:
      'It is designed for barber instructors, barber school teachers, academy owners and professionals who teach barbering.',
  },
  {
    question: 'Does it include lesson plans?',
    answer: 'Yes. The collection includes structured ready-to-teach lessons and supporting classroom resources.',
  },
  {
    question: "Does it cover fades and modern men's haircuts?",
    answer:
      "Yes. The technique library covers classic and modern men's haircutting, fades, tapers, beard techniques and related barbering skills.",
  },
  {
    question: 'Are student worksheets and assessments included?',
    answer: 'Yes. The system includes student practice materials, assessment tools, rubrics and feedback resources.',
  },
  {
    question: 'Can I adapt the materials to my classes?',
    answer:
      'The resources are designed to support different teaching settings. Instructors should adapt them to their curriculum and applicable requirements.',
  },
  {
    question: 'Does this replace official barber instructor certification or state-approved training?',
    answer:
      'No. This is an independent educational resource system, not a professional license or state-approved accreditation program.',
  },
  {
    question: 'How do I receive the product?',
    answer: "The product is delivered digitally after purchase, according to the checkout's delivery process.",
  },
  {
    question: 'Is the payment secure?',
    answer: 'Yes. Checkout is secure and encrypted, and your payment is processed in your local currency.',
  },
]
